export default __webpack_public_path__ + "static/process-4-fc958ee00057105be7d7f50b6b08bc33.png";